import { Component } from '@angular/core';
import { ApiService } from '../shared/services/api.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonService } from '../shared/services/common.service';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatModule } from '../appModules/mat.module';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableDataSource } from '@angular/material/table';
import { CommonModule } from '@angular/common';

interface YearOption {
  value: string;
  Text: string;
}

@Component({
  selector: 'app-nad-report',
  imports:[ReactiveFormsModule, MatModule, MatSelectModule, MatFormFieldModule, MatInputModule, CommonModule],
  templateUrl: './nad-report.component.html',
  styleUrl: './nad-report.component.scss'
})
export class NADReportComponent {

  dataSource: any = new MatTableDataSource([]);
  
  months: any;
  yearss: any;
  courseNames:any;
  displayedColumns: any = {
  label: ['sno', 'Org Code', 'Org Name', 'Org Name (Local)', 'Address', 'City', 'state', 'PIN', 'Course ID', 'courseName',
          'Course Subtitle', 'Duration', 'register_no', 'Roll No', 'ABC Account ID', 'studentName', 'Salutation',
          'Gender', 'dob', 'Caste', 'Religion', 'Nationality', 'PH', 'Mobile', 'Email',
          'father_name', 'mother_name', 'Guardian_Name', 'Student Address', 'Photo',
          'Marks Record Status', 'Result', 'year', 'month', 'Division', 'Grade', 'Percent',
          'Date of Result', 'Date of Issue', 'Certificate No', 'Exam Type', 'cgpa', 'OGPA',
          'Thesis', 'Certificate Name', 'Graduation Level', 'Remarks'],
  cols: ['sno','ORG_CODE','CollegeName','CollegeName_L','ORG_ADDRESS','ORG_CITY','state','ORG_PIN',
         'ACADEMIC_COURSE_ID','courseName','COURSE_SUBTITLE','DURATION','register_no','RROLL',
         'ABC_ACCOUNT_ID','studentName','SALUTATION','GENDER','dob','CASTE','RELIGION','Nationality',
         'PH','MOBILE','EMAIL','father_name','mother_name','Guardian_Name','STUDENT_ADDRESS','PHOTO','MRKS_REC_STATUS',
         'RESULT','year','month','DIVISION','GRADE','PERCENT','DOR','DOI','CERT_NO','EXAM_TYPE',
         'cgpa','OGPA','THESIS','CERT_NAME','GRADUATION_LEVEL','REMARKS']
};

  pagination = {
    length: 0,
    page: 1,
    limit: 5,
  };
  isCollegeList=false;
  currentPage=0;
constructor(private apiService: ApiService, private fb: FormBuilder, private common: CommonService) {}

public cYear: number = new Date().getFullYear();

  public currentYear: Array<YearOption> = [
    { value: "0", Text: "Select" },
    { value: this.cYear.toString(), Text: this.cYear.toString() },
    { value: (this.cYear - 1).toString(), Text: (this.cYear - 1).toString() },
    { value: (this.cYear - 2).toString(), Text: (this.cYear - 2).toString() },
    { value: (this.cYear - 3).toString(), Text: (this.cYear - 3).toString() },
    { value: (this.cYear - 4).toString(), Text: (this.cYear - 4).toString() },
    { value: (this.cYear - 5).toString(), Text: (this.cYear - 5).toString() },
    { value: (this.cYear - 6).toString(), Text: (this.cYear - 6).toString() }
  ];

  NADForm: FormGroup;
  
    ngOnInit(): void {
     
      this.NADForm = this.fb.group({
        selectedMonth: ['', Validators.required],
        selectedYear: ['', Validators.required],
        selectCourse: ['', Validators.required],
      });
      this.month_list();
      this.year_list();
      this.getCourseDropDOwn();
  }


    month_list() {
    this.apiService.get('settings/month_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.months = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  year_list() {
    this.apiService.get('settings/year_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.yearss = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

   getCourseDropDOwn() {
    this.apiService.get(`settings/courseDropDown`).subscribe((resp: any) => {
      if (resp.status) {
        this.courseNames = resp.data;

      } else {
        this.common.notification(resp.message);
      }
    });
  }
 
  getNADReport()
  {
    const data=this.NADForm.value;
    
    this.apiService.post(`results/getNADReport`,data).subscribe(response=>{
      if(response.status){
        this.isCollegeList=true;
        this.dataSource=response.data;
      }else{
        this.common.notification("there is no NAD data for the selected fields")
      }
    });
   
  }
}
